
export const SET_PAGE_VISIBILITY = 'SET_PAGE_VISIBILITY';

export function pageVisibility(pageVisibilityStatus) {

    return {
        type: SET_PAGE_VISIBILITY,
        payload: pageVisibilityStatus
    };
}
